/**
 * @module services/capabilities
 * @description UC-REG-314 — Capacidades del tenant resueltas por la API
 *              (`GET /organization/me` → `capabilities`, perfil por código en
 *              `quantux-api/config/tenant-profiles.js`, sin env vars). El
 *              Dashboard solo las lee para mostrar u ocultar UI; la API hace
 *              cumplir la regla en sus endpoints.
 */

/**
 * @description ¿El contexto de la org trae la capacidad encendida?
 * @param {Object|null} organizationContext - `store.state.organizationContext`
 * @param {string} key - clave de la capacidad (p. ej. `patientChronicConditions`)
 * @returns {boolean} true solo con el booleano `true`
 */
export function hasCapabilityIn(organizationContext, key) {
  return !!(
    organizationContext &&
    organizationContext.capabilities &&
    organizationContext.capabilities[key] === true
  );
}

export default { hasCapabilityIn };
